import { render, staticRenderFns } from "./SidebarBlock.vue?vue&type=template&id=b4345646&scoped=true"
import script from "./SidebarBlock.vue?vue&type=script&lang=js"
export * from "./SidebarBlock.vue?vue&type=script&lang=js"
import style0 from "./SidebarBlock.vue?vue&type=style&index=0&id=b4345646&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4345646",
  null
  
)

export default component.exports